
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Manche Menschen können das tatsächlich – luzides Träumen nennt man dieses Talent. In Klarträumen, wie luzide Träume auch genannt werden, kann man die Handlung bewusst steuern oder sich Superkräfte zulegen – fliegen etwa. Was so magisch klingt, ist gar nicht mal so selten: `}<M mdxType="M">{`Schätzungsweise mehr als die Hälfte aller Erwachsenen hat bereits wenigstens einmal im Leben einen Klartraum erlebt,`}</M>{` wie britische Forscher herausfanden. `}<br /><br />{`
Doch wie lassen sich diese Träume herbeiführen? Gemäss australischen Forschern und ihrem Artikel im Fachblatt «Dreaming» ist eine Technik besonders effektiv: die «traum-induzierten luziden Träume» (DILDs). Bei DILDs wird dem Träumenden während eines «normalen» Traums mit einem Mal klar, dass er träumt, wodurch er die Kontrolle über das Geschehen übernehmen kann. Die Erkenntnis zu träumen, wird unter anderem über einen Realitätstest erreicht. Dieser beginnt im Wachzustand. Dabei stellt man sich mehrmals täglich die einfache Frage: Träume ich? Ist irgendetwas in meiner Umgebung ungereimt? Die Idee ist, dass man sich mithilfe dieser Routine die Frage irgendwann auch im Traum stellt – und sie bejaht, was dann einen Klartraum auslöst. `}<br /><br />{`
Im Internet findet sich eine ganze Reihe weiterer Anleitungen, wie man die Technik des luziden Träumens lernen kann, die heute auch wissenschaftlich anerkannt ist. Denn Forscher sind inzwischen überzeugt: Der Klartraum, einst als Hirngespinst abgetan, kann bei der Therapie von Albträumen helfen.`}<br /><br /></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;